<template>
  <v-container class="talktrend-saved px-6 pt-0 pb-3">
    <v-row class="talktrend-saved__content ma-0 pa-0">
      <v-col
        class="talktrend-saved__panel ma-0 pa-0"
        cols="12"
        v-if="page_loading && audience_data.length === 0"
      >
        <v-row
          class="talktrend-saved__loading-row ma-0 pa-0"
          align="center"
          justify="center"
        >
          <v-col cols="auto">
            <v-progress-circular
              color="black"
              size="100"
              indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="talktrend-saved__panel ma-0 pa-0" cols="12" v-else>
        <EntityDirectory
          entity_name="Audience"
          :directory_data="audience_data"
          :loading="directory_loading"
          :available_create_options="['create_folder']"
          :item_subcontent_config="item_subcontent_config"
          v-on:open_entity="open_audience"
          v-on:edit_entity_name="update_audience"
          v-on:delete_entity="delete_audience"
          v-on:move_files="move_audiences"
          v-on:create_entity_folder="create_new_folder"
          v-on:reset_directory="get_audiences"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import audience_api_caller from "@/javascript/audience.js";
import EntityDirectory from "@/components/Utility/EntityDirectory.vue";
import {
  ALERT_TYPE_ERROR,
  ALERT_GENERIC_MESSAGE,
} from "@/constants/constants";

export default {
  name: "TalkTrendSaved",
  props: ["project_id"],
  components: {
    EntityDirectory,
  },
  data: () => ({
    client_id: "0000",
    page_loading: true,
    saved_report_loading: true,
    item_subcontent_config: [
      { key: "status", label: "Status" },
      { key: "updated_time", label: "Last Update" },
    ],
  
    audience_data: [],
  }),
  async mounted() {
    await this.get_audiences();
    this.page_loading = false;
  },
  watch: {},
  computed: {
    directory_loading() {
      return this.saved_report_loading;
    },
  },
  methods: {
    get_audiences: async function () {
      this.saved_report_loading = true;
      let payload = {
        project_id: this.$project.get_val(),
      };

      let token = await this.$auth.getTokenSilently();

      let result = await audience_api_caller
        .fetch_audience(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });
      if (result && result["audience_data"]) {
        this.audience_data = result["audience_data"];
      } else {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
      }
      this.saved_report_loading = false;
    },

    delete_audience: async function (audience_id) {
      this.saved_report_loading = true;
      let payload = {
        client_id: this.client_id,
        audience_id: audience_id,
      };

      let token = await this.$auth.getTokenSilently();
      let result = await audience_api_caller
        .delete_audience(token, payload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });

      if (!result || !result["audience_id"]) {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
      }
      await this.get_audiences();
    },
    create_new_folder: async function (payload) {
      let createPayload = {
        audience_data: {
          audience_name: payload.folder_name,
          parent_id: payload.parent_id,
        },
        project_id: this.$project.get_val(),
      };

      let token = await this.$auth.getTokenSilently();
      let result = await audience_api_caller
        .create_audience(token, createPayload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });

      if (!result || !result["audience_id"]) {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
      } else {
        await this.get_audiences();
      }
    },
    update_audience: async function (payload) {
      if (payload && payload.id) {
        let update_payload = {
          client_id: this.client_id,
          audience_id: payload.id,
          update_vals: {
            audience_name: payload.name,
          },
        };

        let token = await this.$auth.getTokenSilently();
        let result = await audience_api_caller
          .update_audience(token, update_payload)
          .then((resp) => {
            if (resp["success"]) {
              return resp["data"];
            }
            return false;
          })
          .catch((e) => {
            console.log("error", e);
            return false;
          });

        if (!result || !result["audience_id"]) {
          this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
        }
      }
      await this.get_audiences();
    },
    move_audiences: async function (payload) {
      const audienceIds = (payload.entity_ids || []).map((id) => Number(id));

      if (
        audienceIds.length === 0 ||
        payload.parent_id === null ||
        payload.parent_id === undefined
      ) {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
        return;
      }

      this.saved_report_loading = true;
      let movePayload = {
        project_id: this.$project.get_val(),
        audience_ids: audienceIds,
        parent_id: payload.parent_id,
      };

      let token = await this.$auth.getTokenSilently();
      let result = await audience_api_caller
        .move_audiences(token, movePayload)
        .then((resp) => {
          if (resp["success"]) {
            return resp["data"];
          }
          return false;
        })
        .catch((e) => {
          console.log("error", e);
          return false;
        });

      if (result) {
        await this.get_audiences();
      } else {
        this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
        this.saved_report_loading = false;
      }
    },
    open_audience: function (audience_id) {
      if (this.directory_loading) {
        return;
      }

      this.$emit("open_audience", audience_id);
    },
  },
};
</script>

<style scoped>
.talktrend-saved {
  max-width: 100%;
  height: 100%;
}

.talktrend-saved__content {
  width: 100%;
  height: 100%;
}

.talktrend-saved__panel {
  height: 100%;
}

.talktrend-saved__loading-row {
  width: 100%;
  height: 100%;
}

/* .data_breakdown_chip {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 0.85em;
  width: 150px;
} */
.card_wrapper_folder {
  margin-top: 20px;
}
.card_title {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 0.8em;
}

.card_section_header {
  font-family: "Poppins" !important;
  font-weight: 700;
  font-size: 0.8em;
  display: flex;
  align-items: center;
  padding-left: 10px;
}
.no_saved {
  font-family: "Poppins" !important;
  font-weight: 200;
  font-size: 1.3em;
}
</style>
